/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Checklist_Changed_OnlyInputs */

const en_audit_checklist_changed_only = /** @type {(inputs: Audit_Checklist_Changed_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only lots where the actual count differs from expected are submitted.`)
};

const es_audit_checklist_changed_only = /** @type {(inputs: Audit_Checklist_Changed_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se envian los lotes cuyo conteo real difiere del esperado.`)
};

/**
* | output |
* | --- |
* | "Only lots where the actual count differs from expected are submitted." |
*
* @param {Audit_Checklist_Changed_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_checklist_changed_only = /** @type {((inputs?: Audit_Checklist_Changed_OnlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Checklist_Changed_OnlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_checklist_changed_only(inputs)
	return es_audit_checklist_changed_only(inputs)
});